import Scriba from 'react-scriba';

export class DataIndicateur {

    static _chargementFicheDetailIndicateurRecapitulatif(idOperation, mois, annee) {
        let objet = {
            "idOperation": idOperation,
            "numMois": mois,
            "annee": annee
        };

        var url = "api/Get/GetDetailIndicateurRecapitulatif";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementFicheDetailIndicateurValidation(idOperation, idReservation, idLotCommercial) {
        let objet = {
            "idOperation": idOperation,
            "idReservation": idReservation,
            "idLotCommercial": idLotCommercial
        };

        var url = "api/Get/GetDetailIndicateurValidation";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementListeDesINDICATEURSPrevision(tri, filtreMois, filtreAnnee, facteurNbreEnregistrement, pageIndex) {
        let objet = {
            "tri": tri,
            "filtreMois": filtreMois,
            "filtreAnnee": filtreAnnee,
            "nbreEnreg": facteurNbreEnregistrement,
            "pageIndex": pageIndex
        };

        /* YD : 20230224 : first step implement RegionMetier dans Indicateur */
        var url = "api/v2/Liste/ListeDesINDICATEURSPrevision";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementListeDesINDICATEURSRecapitulatif(tri, filtreMois, filtreAnnee, facteurNbreEnregistrement, pageIndex) {
        let objet = {
            "tri": tri,
            "filtreMois": filtreMois,
            "filtreAnnee": filtreAnnee,
            "nbreEnreg": facteurNbreEnregistrement,
            "pageIndex": pageIndex
        };

        /* YD : 20230224 : first step implement RegionMetier dans Indicateur */
        var url = "api/v2/Liste/ListeDesINDICATEURSRecapitulatif";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementListeDesINDICATEURSReintegration(tri, filtreMois, filtreAnnee, facteurNbreEnregistrement, pageIndex) {
        let objet = {
            "tri": tri,
            "filtreMois": filtreMois,
            "filtreAnnee": filtreAnnee,
            "nbreEnreg": facteurNbreEnregistrement,
            "pageIndex": pageIndex
        };

        /* YD : 20230224 : first step implement RegionMetier dans Indicateur */
        var url = "api/v2/Liste/ListeDesINDICATEURSReintegration";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementListeDesINDICATEURSValidation(tri, filtreMois, filtreAnnee, filtreNumLot, filtreResaDesisNonValidees, filtreResaDesistValidees, facteurNbreEnregistrement, pageIndex) {
        let objet = {
            "tri": tri,
            "filtreMois": filtreMois,
            "filtreAnnee": filtreAnnee,
            "filtreNumLot": filtreNumLot,
            "filtreResaDesistNonValidees": filtreResaDesisNonValidees,
            "filtreResaDesistValidees": filtreResaDesistValidees,
            "nbreEnreg": facteurNbreEnregistrement,
            "pageIndex": pageIndex
        };

        /* YD : 20230224 : first step implement RegionMetier dans Indicateur */
        var url = "api/v2/Liste/ListeDesINDICATEURSValidation";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementIndicateur(idIndicateur) {
        let objet = {
            "idIndicateur": idIndicateur
        };

        var url = "api/Get/GetIndicateur";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onEnregistrementIndicateur(indicateur, type) {
        let objet = {
            "indicateur": indicateur,
            "type": type
        };

        var url = "api/MAJDonnees/EnregistrementIndicateur";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onEnregistrementIndicateurClotureRegionale() {

        var url = "api/MAJDonnees/EnregistrementIndicateurClotureRegionale";
        var paramPost = Scriba.fetch().createParameterPost({});

        return fetch(url, paramPost).then(response => response.json());
    }
    static _onEnregistrementIndicateurClotureNationale() {

        var url = "api/MAJDonnees/EnregistrementIndicateurClotureNationale";
        var paramPost = Scriba.fetch().createParameterPost({});

        return fetch(url, paramPost).then(response => response.json());
    }
    static _onEnregistrementIndicateurDeclotureRegionale() {

        var url = "api/MAJDonnees/EnregistrementIndicateurDeclotureRegionale";
        var paramPost = Scriba.fetch().createParameterPost({});

        return fetch(url, paramPost).then(response => response.json());
    }
    static _onEnregistrementRecalculIndicateurs() {

        var url = "api/MAJDonnees/EnregistrementRecalculIndicateurs";
        var paramPost = Scriba.fetch().createParameterPost({});

        return fetch(url, paramPost).then(response => response.json());
    }
    static _onEnregistrementOuverturePeriode(dateOuverturePeriode) {
        let objet = {
            "dateOuverturePeriode": dateOuverturePeriode
        };

        var url = "api/MAJDonnees/EnregistrementOuverturePeriode";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }


    static _onEnregistrementValidationOuAnnulationCG(reservations, onValide) {
        let objet = {
            "reservations": reservations,
            "onValide": onValide
        };

        var url = "api/MAJDonnees/EnregistrementValidationOuAnnulationCG";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    /* YD : 20230407 : 2240 */
    static _chargementListeDesIndicateursEnDecalage() {
        var url = "api/v2/Liste/ListeDesINDICATEURSEnDecalage";
        var paramPost = Scriba.fetch().createParameterPost();

        return fetch(url, paramPost).then(response => response.json());
    }

    /* 20230516 : YD : 2349 : rien à voir avec ce ticket mais j'en profite pour implémenter l'affichage ou pas des onglets du CG si periode est ouverte ou pas */
    static _chargementPeriodeOuvertureEnCours() {
        let objet = {
        };

        var url = "api/Get/GetPeriodeOuvertureEnCours";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

}
